module.exports = __webpack_public_path__ + "vue-app/img/fly-ski-free.7f591f21.svg";